"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STYLES_MAP = void 0;
// 0(zero) for price = null;

var STYLES_MAP = exports.STYLES_MAP = {
  0: {
    background: '#fff',
    segmentColor: {
      color: '#c2c5cc',
      opacity: 1
    },
    priceColor: '#c2c5cc'
  },
  1: {
    background: '#fbfdf2',
    segmentColor: {
      color: '#919499',
      opacity: 1
    },
    priceColor: '#17181A'
  },
  2: {
    background: '#fbfdf2',
    segmentColor: {
      color: '#919499',
      opacity: 1
    },
    priceColor: '#17181A'
  },
  3: {
    background: '#f1f7d2',
    segmentColor: {
      color: '#17181A',
      opacity: 0.5
    },
    priceColor: '#17181A'
  },
  4: {
    background: '#cce763',
    segmentColor: {
      color: '#17181A',
      opacity: 0.5
    },
    priceColor: '#17181A'
  },
  5: {
    background: '#6abf40',
    segmentColor: {
      color: '#cce763',
      opacity: 1
    },
    priceColor: '#ffffff'
  }
};